import { elementController } from '@public-pages/runtime-core';
import { faq } from "./data"


elementController('faq', ({ query, queryAll }) => {
  const showMoreBtn = query('.faq__content-button')
  const cards = queryAll('.accordion__card')
  const maxCards = 4;

  if (cards.length > maxCards) {
    cards.map((card, index) => {
      if (index >= maxCards) {
        card.classList.add('hide');
      }
    })
  }

  showMoreBtn?.addEventListener('click', () => {
    cards.map((card) => card.classList.remove('hide'))
    showMoreBtn.classList.add('hide')
  })
});
